var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5913_1218)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 50.5105C38.031 50.5105 49 39.5415 49 26.0105C49 12.4795 38.031 1.5105 24.5 1.5105C10.969 1.5105 0 12.4795 0 26.0105C0 39.5415 10.969 50.5105 24.5 50.5105Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5913_1218",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 39,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2855 7.22729H5.71875V44.794H43.2855V7.22729Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5913_1218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7516 14.9803L26.2545 9.48546C25.035 8.89647 23.5971 8.97616 22.4498 9.69717L10.5861 17.168C9.4388 17.889 8.74414 19.1529 8.75004 20.5072L8.79375 33.212C8.79976 34.7137 9.66102 36.0822 11.0133 36.7374L22.5105 42.2323C23.73 42.8213 25.1678 42.7416 26.3152 42.0206L38.1788 34.5497C39.3261 33.8287 40.0208 32.5649 40.0148 31.2106L39.9927 24.38L39.9736 18.5058C39.9677 17.004 39.1063 15.6356 37.7565 14.9827L37.7516 14.9803Z",
    fill: "#FAFAFA",
    stroke: "#383E47",
    strokeWidth: 1.44118,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5299 37.7657L13.3321 33.8465C12.494 33.4403 11.9483 32.5739 11.9453 31.6402L11.9141 22.4668",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5299 37.7658L13.3321 33.8465C12.494 33.4403 11.9483 32.5739 11.9453 31.6402L11.9141 22.4668",
    stroke: "#383E47",
    strokeWidth: 1.15294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0625 21.8591L22.1136 25.27C22.9473 25.6827 23.4886 26.547 23.4915 27.4786L23.5198 35.5572",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0625 21.8591L22.1136 25.27C22.9473 25.6827 23.4886 26.547 23.4915 27.4786L23.5198 35.5572",
    stroke: "#383E47",
    strokeWidth: 1.15294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9286 26.2581L11.9141 21.7005C11.9138 21.2917 12.1973 21.068 12.3202 20.9898C12.443 20.9137 12.769 20.7527 13.1378 20.9311L15.4733 22.0598",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9286 26.2581L11.9141 21.7005C11.9138 21.2917 12.1973 21.068 12.3202 20.9898C12.443 20.9137 12.769 20.7527 13.1378 20.9311L15.4733 22.0598",
    stroke: "#383E47",
    strokeWidth: 1.15294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5067 32.4453L23.5237 37.4386C23.5239 37.8451 23.2583 38.0575 23.1445 38.1292C23.0305 38.2008 22.7245 38.3507 22.358 38.1723L17.1953 35.7094",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5067 32.4453L23.5237 37.4386C23.5239 37.8451 23.2583 38.0575 23.1445 38.1292C23.0305 38.2008 22.7245 38.3507 22.358 38.1723L17.1953 35.7094",
    stroke: "#383E47",
    strokeWidth: 1.15294,
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5913_1218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    transform: "translate(0 0.645996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature);
export default __webpack_public_path__ + "static/media/feature.2f15d4eca4558a11126068e94e4a0748.svg";
export { ForwardRef as ReactComponent };